import "./body.css";
import "antd/dist/antd.css";
import './App.less';
import React, { useState, useContext, useEffect } from "react";
import "@ant-design/compatible";
import { ApolloProvider } from "@apollo/react-hooks";
import { Layout, Row, Col } from "antd";
import cubejs from "@cubejs-client/core";
import { CubeProvider } from "@cubejs-client/react";
import client from "./graphql/client";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import "filepond/dist/filepond.min.css";
import AppContext from "./context/AppContext";
import styles from "./pages/styles.js";
import { useAuth0 } from "@auth0/auth0-react";
import Auth0ProviderWithHistory from "./components/auth0/AuthProviderWithHistory";

let apiTokenPromise;
const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000"
    : process.env.REACT_APP_CUBE_API;
const CUBEJS_TOKEN = process.env.REACT_APP_CUBE_TOKEN;
// const API_URL = process.env.REACT_APP_CUBE_API;
const getToken = () => {
  if (!apiTokenPromise) {
    if (process.env.NODE_ENV === "development") {
      console.log("In development");
      apiTokenPromise = CUBEJS_TOKEN;
    } else {
      apiTokenPromise = fetch(process.env.REACT_APP_CUBE_TOKENGEN_API)
        .then((res) => res.json())
        .then((r) => r.token);
    }
  }
  return apiTokenPromise;
};
const cubejsApi = cubejs(getToken, {
  apiUrl: `${API_URL}/cubejs-api/v1`,
});

const AppLayout = ({ children }) => {
  const { isAuthenticated } = useAuth0();
  const [collapsed, setCollapsed] = useState(true);

  return (
    <>
      {/* <Layout style={styles.layout(isAuthenticated)}> */}
      <Row style={styles.layout()}>
        <Col flex='80px'>
          <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        </Col>
        <Col flex='auto'>
          {/* <Layout style={{ overflow: 'hidden' }} > */}
          {isAuthenticated && <Header collapsed={collapsed} setCollapsed={setCollapsed} />}

          <Layout.Content>
            {children}
          </Layout.Content>
          {/* </Layout> */}
        </Col>
      </Row>



      {/* </Layout> */}
    </>
  );
};

const App = ({ children }) => {
  const [exportProgress, setExportProgress] = useState({
    progress: 0,
    status: "normal",
    message: "",
  });

  const contextValues = {
    exportProgress,
    setExportProgress,
  };

  return (
    <CubeProvider cubejsApi={cubejsApi}>
      <ApolloProvider client={client}>
        <Auth0ProviderWithHistory>
          <AppContext.Provider value={contextValues}>
            <AppLayout>{children}</AppLayout>
          </AppContext.Provider>
        </Auth0ProviderWithHistory>
      </ApolloProvider>
    </CubeProvider>
  );
};

export default App;
